import styled from '@emotion/styled'
import tw from 'twin.macro'

export const ButtonLink = styled.div`
  .button,
  .disabledButton,
  .pageNumber,
  .currentPageNumber {
    ${tw`
      flex
      flex-row
      items-center
      no-underline
      text-base
      md:text-lg
      lg:text-xl
      text-purple-300
      hover:text-purple-900
    `}
  }

  .pageNumber,
  .currentPageNumber {
    ${tw`
      flex
      items-center
      justify-center
      w-6
      h-6
      md:w-12
      md:h-12
      m-0.5
      p-0.5
      md:m-1.5
      md:p-1.5
      lg:m-3
      lg:p-3
    `}
  }

  .disabledButton {
    ${tw`
      pointer-events-none
      text-purple-200
    `}
  }

  .currentPageNumber {
    ${tw`
      pointer-events-none
      text-purple-900
      rounded-full
    `}
    background-color: #F3EEFB;
  }

  a[rel~='prev'],
  a[rel~='next'],
  a[rel~='back-to-top'] {
    ${tw`
      font-bold
    `}
  }
  a[rel~='back-to-top'] {
    ${tw`
      mb-6
      lg:mb-0
    `}
  }
  a[rel~='prev'],
  a[rel~='next'] {
    ${tw`
      m-0.5
      p-0.5
      md:m-1.5
      md:p-1.5
      lg:m-3
      lg:p-3
    `}
  }
  a[rel~='prev'].disabledButton,
  a[rel~='next'].disabledButton,
  a[rel~='first'].disabledButton,
  a[rel~='last'].disabledButton {
    ${tw`
      hidden
    `}
  }

  a[rel~='first'],
  a[rel~='last'] {
    ${tw`
      hidden
      lg:block
    `}
  }

  svg {
    ${tw`
      h-5 w-5
    `}
  }
`

export const PaginationFlex = styled.div`
  ${tw`
    flex 
    flex-row
    items-center
  `}
`

export const Wrapper = styled.div`
  ${tw`
    flex 
    flex-col
    lg:flex-row
    items-center
    justify-between
    pt-16
  `}
`
